import Intro from "../../../../src/components/v8-ignition/intro";
import * as React from 'react';
export default {
  Intro,
  React
};